/**
 * 动态加载翻译文件的函数
 * 使用静态导入 + 映射的方式，避免动态路径解析问题
 */

import enMessages from "./locales/en.json"
import esMessages from "./locales/es.json"
import frMessages from "./locales/fr.json"
import idMessages from "./locales/id.json"
import koMessages from "./locales/ko.json"
import ptMessages from "./locales/pt.json"
import ruMessages from "./locales/ru.json"
import thMessages from "./locales/th.json"
import vnMessages from "./locales/vn.json"

export type SupportedLocale = "en" | "es" | "fr" | "id" | "ko" | "pt" | "ru" | "th" | "vn"

export type Messages = Record<string, unknown>

// 翻译文件映射表
const messagesMap: Record<SupportedLocale, Messages> = {
  en: enMessages,
  es: esMessages,
  fr: frMessages,
  id: idMessages,
  ko: koMessages,
  pt: ptMessages,
  ru: ruMessages,
  th: thMessages,
  vn: vnMessages,
}

/**
 * 加载指定语言的翻译文件
 * @param locale 语言代码 (en, th)
 * @returns 翻译文件内容
 */
export function loadMessages(locale: string): Messages {
  return messagesMap[locale as SupportedLocale] ?? messagesMap.en
}

/**
 * 获取所有支持的语言列表
 */
export const supportedLocales: SupportedLocale[] = ["en", "es", "fr", "id", "ko", "pt", "ru", "th", "vn"]

/**
 * 检查语言是否支持
 */
export function isLocaleSupported(locale: string): locale is SupportedLocale {
  return supportedLocales.includes(locale as SupportedLocale)
}
